import { Nexset } from 'new/entities/Nexset';

/**
 * Determines if a nexset should be discoverable (shown in list views).
 *
 * Note: Operational nexsets (splitter, api_endpoint, etc.) should only appear
 * in flow canvas views, not in list views.
 *
 * @param nexset - The nexset to check
 * @returns true if the nexset should appear in list views, false otherwise
 */
export function isDiscoverable(
  nexset: Nexset | { discoverable_data?: boolean; operational?: boolean },
): boolean {
  return nexset.discoverable_data !== false;
}

/**
 * Determines if a nexset is operational (should only appear in flow views).
 *
 * @param nexset - The nexset to check
 * @returns true if the nexset is operational, false otherwise
 */
export function isOperational(nexset: Nexset | { operational?: boolean }): boolean {
  return nexset.operational === true;
}

/**
 * Determines if a nexset is eligible for the marketplace.
 *
 * @param nexset - The nexset to check
 * @returns true if the nexset is eligible for the marketplace, false otherwise
 */
export function isMarketplaceEligible(
  nexset: Nexset | { marketplace_eligible?: boolean; operational?: boolean },
): boolean {
  return nexset.marketplace_eligible === true && !isOperational(nexset);
}
